import NewBookkeepingAccountPopup from '@/bookkeeping-account/NewBookkeepingAccountPopup.vue'
import { useContaCommand } from '@/commandbar/commandBar.service'
import useDynamicComponentLoader from '@/dynamic-component-loader/dynamicComponent.service'
import { bookkeepingAccounts } from '@/bookkeeping-account/bookkeepingAccount.service'
import { usePanelManager } from '@tritt/multipanel'
import { watch } from 'vue'
import { GENERAL_LEDGER } from '@/genleg'
import { BookkeepingAccount } from '@/bookkeeping-account/BookkeepingAccount'
import { PanelContentRequest } from '@tritt/multipanel'

const { loadComponent } = useDynamicComponentLoader()
const { registerCommand, unregisterCommandsOfType } = useContaCommand()
const CONTA_COMMAND_TYPE = 'bookkeeping-account'

const navToAccount = (account: BookkeepingAccount, targetPanel: number) => {
    const payload: PanelContentRequest = {
        componentName: GENERAL_LEDGER.componentName,
        queryValues: { accountNo: account.accountNo},
        panelId: targetPanel,
    }

    const { setPanelPath } = usePanelManager()
    setPanelPath(payload)
}

registerCommand({
    type: 'new-bookeeping-account',
    typeLabel: 'Konto',
    label: 'Ny konto',
    key: 'new-account',
    icon: 'i-mdi-plus',
    activate: () => {
        loadComponent(NewBookkeepingAccountPopup)
    },
    isActive: () => false
})

watch(bookkeepingAccounts, () => {
    unregisterCommandsOfType(CONTA_COMMAND_TYPE)
    const accounts = bookkeepingAccounts.value || []
    accounts.forEach(account => {
        registerCommand({
            type: 'account',
            typeLabel: 'Konto',
            label: account.accountNo + ' : ' + account.name,
            key: account.accountNo,
            icon: 'i-mdi-text-box',
            showPanelSelector: true,
            activate: (targetPanel: number) => navToAccount(account, targetPanel),
            isActive: () => false
        })
    })
})